import { makeObservable, observable, flow, computed } from "mobx";

import { api } from "@/lib/services";
import { ApiRoutes } from "@/lib/routes";

import BrowseReportsSchema from "@/areas/analytics/schemas/BrowseReportsSchema";
import { Add } from "@/components/icons/IconMap";

export default class BrowseReportsStore {
  loading = false;
  pagination = null;
  reports = [];

  constructor(parentStore) {
    makeObservable(this, {
      loading: observable,
      pagination: observable,
      reports: observable,
      actions: computed,
      load: flow,
    });

    this.parentStore = parentStore;
  }

  get actions() {
    const list = [];

    list.push({
      id: "compliance:reports:create",
      label: "New Report",
      onClick: () => this.parentStore.createReportStore.show(),
      icon: Add,
      location: "primary",
      processing: this.parentStore.createReportStore.processing,
      disabled: this.parentStore.createReportStore.processing,
    });

    return list;
  }

  consume(report) {
    const index = this.reports.findIndex((e) => e.id === report.id);
    if (index !== -1) {
      this.reports.splice(index, 1, report);
      this.reports = [...this.reports];
    }
  }

  *load(query, options) {
    const parseResult = BrowseReportsSchema.safeParse(query);
    if (!parseResult.success) {
      return parseResult;
    }
    try {
      this.loading = true;
      const response = yield api.post(ApiRoutes.forReportSearch(), query);
      this.reports = response.data.items;

      //this.reports = [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }];
      this.pagination = {
        page: response.data.page,
        totalItems: response.data.totalItems,
        totalPages: response.data.totalPages,
        pageSize: response.data.pageSize,
      };
      return { success: true, data: response.data };
    } catch (e) {
      return { success: false, error: e };
    } finally {
      this.loading = false;
    }
  }
}
